import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { listHomeCards } from "./homeCards";

/**
 * GuideHomeCards - griglia delle Card Operative Foundation.
 *
 * Componente Foundation riutilizzabile: legge le Card dal registry
 * `homeCards.js` e le renderizza filtrandole per ruolo utente. Nessun
 * testo, icona o percorso e' hardcoded qui: sono tutti forniti dal registry.
 *
 * Props:
 *   - role?: string          - ruolo dell'utente (default "*")
 *   - packs?: string[]       - filtra le Card per Pack di appartenenza
 *   - className?: string
 */
export function GuideHomeCards({ role = "*", packs, className = "" }) {
  const cards = useMemo(() => listHomeCards(role, { packs }), [role, packs]);
  if (!cards.length) return null;
  return (
    <section
      className={`grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3 ${className}`}
      data-testid="guide-home-cards"
    >
      {cards.map((c) => {
        const Icon = LucideIcons[c.icon] || LucideIcons.BookOpen;
        return (
          <Link
            key={c.id}
            to={c.to}
            className="group flex items-start gap-3 rounded-lg border border-suite-neutral-200 bg-white p-4 transition-shadow hover:border-suite-primary/40 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-suite-primary/40"
            data-testid={`guide-home-card-${c.id}`}
          >
            <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-suite-primary/10 text-suite-primary group-hover:bg-suite-primary/15">
              <Icon size={18} strokeWidth={1.75} />
            </div>
            <div className="min-w-0">
              <div className="text-sm font-semibold text-suite-neutral-900">
                {c.title}
              </div>
              <div className="mt-0.5 text-xs leading-relaxed text-suite-neutral-500">
                {c.description}
              </div>
            </div>
          </Link>
        );
      })}
    </section>
  );
}
